<template>
    <div class="o-guide guide">
        <div class="guide__header">
            <!--<div class="guide__row">
                <span class="guide__headline" @click="buildPath">
                    {{ $t('o-guide_headline') }}
                </span>
                <svg-icon
                    original
                    name="icons/path-white"
                    class="guide__header-icon"
                />
            </div>-->
            <div class="guide__header-tile">
                <span class="guide__header-tile-headline">
                    <svg-icon
                        original
                        name="icons/marker"
                        class="guide-headline__icon"
                    />
                    <span class="guide__header-tile-headline-text">
                        {{ t(item, 'name') }}
                    </span>
                </span>
                <AItemInfo
                    :item="item"
                />
            </div>
        </div>
        <div class="guide__container">
            <AGuideOverviewButton
                :iconPath="true"
                isDistanceShow
                @onClick="handleClickOverview"
            />
            <OGuideSteps v-model="currentStep"/>
            <OGuideFooter />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AGuideOverviewButton from '../../atoms/a-guide-overview-button/a-guide-overview-button';
import AItemInfo from '../../atoms/a-item-info/a-item-info';
import OGuideSteps from '../../unique-organisms/o-guide-steps/o-guide-steps';
import OGuideFooter from '../../unique-organisms/o-guide-footer/o-guide-footer';

import {
    UI_MAP_READY,
    STOP_VIEW_API,
    START_VIEW_API,
    MAP_SHOW_PATH_STEPS,
    UI_STEP_BY_STEP_DIRECTIONS
} from '../../../shared/components/map-viewer/constants/map-events';

import { MAP_SHOW_PATH } from '../../../shared/components/map-viewer/constants/map-commands';

export default {
    name: "OGuide",
    data() {
        return {
            currentStep: null
        }
    },
    components: {
        AItemInfo,
        OGuideSteps,
        AGuideOverviewButton,
        OGuideFooter
    },
    computed: {
        ...mapGetters([
            't',
            'isAppLoaded',
            'getMapLoading',
            'getTerminalId',
            'getCategoryById',
            'getMapConfigProp',
            'getTerminalConfig',
            'getDenormalisedObjectById'
        ]),
        itemId() {
            return parseInt(this.$route.params.id, 10);
        },
        item() {
            return this.getDenormalisedObjectById(this.itemId);
        },
    },
    // beforeRouteLeave(to, from, next) {
    //     if (to.name.includes("guide")) this.$bus.$emit(START_VIEW_API);
    //     else this.$bus.$emit(STOP_VIEW_API);
    //     next();
    // },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    mounted () {
        this.initEventListeners();
        if (this.isAppLoaded && !this.getMapLoading) this.buildPath();
    },
    watch: {
        item() {
            this.buildPath();
        }
    },
    methods: {
        initEventListeners() {
            this.$bus.$on(UI_MAP_READY, this.mapReady);
            this.$bus.$on(UI_STEP_BY_STEP_DIRECTIONS, this.setActivePath);
        },
        deactivateEventsListeners() {
            this.$bus.$off(UI_MAP_READY, this.mapReady);
            this.$bus.$off(UI_STEP_BY_STEP_DIRECTIONS, this.setActivePath);
        },
        mapReady() {
            if (this.isAppLoaded) this.buildPath();
        },
        setActivePath(data) {
            this.$store.commit('setActivePathToState', data);
            this.$store.commit('setActiveStepIndex', null);
        },
        buildPath() {
            const params = {
                from:{
                    id: this.getTerminalId
                },
                to: {
                    id: this.itemId
                },
                mode: this.getMapConfigProp('guide.mode', 'easy'),
            };
            if( _.has(this.getTerminalConfig, 'cameras.kiosk_orientation') )
                params.initial_orientation = this.getTerminalConfig.cameras.kiosk_orientation;

            // eslint-disable-next-line camelcase
            if(this.item?.meta?.prioritise_outdoor)
                params.use_outside = 'prefer'

            params.portal_rules = this.getMapConfigProp('guide.portal_rules', {});

            this.$bus.$emit(MAP_SHOW_PATH, params);
        },
        handleClickOverview() {
            if (this.currentStep === null) return;
            this.currentStep = null;
            this.buildPath();
        }
    }
}
</script>

<style lang="scss">
@import "o-guide";
</style>
